module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.25941/images/keyFeatures/Instant_247_Support.png"